import { jobFeature } from './job.reducer'

export const { selectJobs } = jobFeature
